<template>
  <div class="white-box position-relative">
    <TileLoader :loading="loading"/>
    <h2>Analyse gammes</h2>
    <div class="btns-container">
      <button
          v-if="annualYear"
          class="btn-cmem"
          :class="{active: sourceType === 1}"
          @click="sourceType = 1">
        Annuelle {{annualYear}}
      </button>
      <button
          v-if="simulationYear"
          class="btn-cmem"
          :class="{active: sourceType === 2}"
          @click="sourceType = 2">
        Simulation {{simulationYear}}
      </button>
    </div>
    <table class="datas-table">
      <thead>
      <tr>
        <th>Gamme</th>
        <th class="number">CA</th>
        <th class="number">Proportion CA Total</th>
        <th class="number">RFA</th>
        <th class="number">Proportion RFA Totale</th>
        <th class="number">Tx RFA</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="row of datas.filter(row => row.SourceType === sourceType)" :key="row.Label">
        <td>{{ row.Label }}</td>

        <td class="number">{{ formatEuro(row.CA, 0) }}
          <div v-if="row.ProgressionCA" class="trend-indicator" :class="row.ProgressionCA >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionCA * 10000) / 100 }}&nbsp;%
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>

        <td class="number">{{ Math.round(row.PropCA * 10000) / 100 }}&nbsp;%
          <div v-if="row.ProgressionPropCA" class="trend-indicator" :class="row.ProgressionPropCA >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionPropCA * 10000) / 100 }}
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>

        <td class="number" v-if="row.Rfa || row.ProgressionRfa">{{ formatEuro(row.Rfa, 0) }}
          <div v-if="row.ProgressionRfa" class="trend-indicator" :class="row.ProgressionRfa >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionRfa * 10000) / 100 }}&nbsp;%
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>
        <td v-else class="number text-muted">N/A</td>

        <td class="number" v-if="row.PropRfa || row.ProgressionPropRfa">{{ Math.round(row.PropRfa * 10000) / 100 }}&nbsp;%
          <div v-if="row.ProgressionPropRfa" class="trend-indicator"
               :class="row.ProgressionPropRfa >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionPropRfa * 10000) / 100 }}
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>
        <td v-else class="number text-muted">N/A</td>

        <td class="number" v-if="row.TxRfa || row.ProgressionTxRfa">{{ Math.round(row.TxRfa * 10000) / 100 }}&nbsp;%
          <div v-if="row.ProgressionTxRfa" class="trend-indicator" :class="row.ProgressionTxRfa >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionTxRfa * 10000) / 100 }}
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>
        <td v-else class="number text-muted">N/A</td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import TileLoader from "../../Dashboards/TileLoader.vue";
import {getFrsCaRfaInfos, getFrsGammesCaRfaInfos, getPaymentsFrs} from "@/utils/dashboardCdm";

export default {
  components: {TileLoader},
  name: 'FrsGammesCaRfaInfosTile',
  props: ["frsGuid"],
  data() {
    return {
      loading: 0,
      datas: [],
      sourceType: 1
    }
  },
  mounted() {
    this.initData();
  },
  watch: {
    frsGuid() {
      this.initData();
    }
  },
  methods: {
    initData() {
      if (!this.frsGuid) return;

      this.loading = 1;
      getFrsGammesCaRfaInfos(this.frsGuid).then(res => {
        if (res.length)
          this.datas = res;
        this.loading = 0;
      })
    },
    formatEuro(value, precision = 2) {
      return Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: precision
      }).format(value);
    },
  },
  computed: {
    annualYear() {
      let annualRow = this.datas.find(row => row.SourceType === 1);
      if (!annualRow) return null;
      return annualRow.Year
    },
    simulationYear() {
      let simulationRow = this.datas.find(row => row.SourceType === 2);
      if (!simulationRow) return null;
      return simulationRow.Year
    }
  }
}
</script>

<style scoped>
.white-box {
  flex: 1 1 35em;
  padding: 12px;

  display: flex;
  flex-direction: column;
}

h2 {
  display: flex;
  align-items: center;

  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.btns-container {
  display: flex;
  gap: 12px;
  margin: 12px 0;
}

.btns-container button:not(.active) {
  background-color: white;
}

p {
  margin: 0;
}

.datas-table thead {
  border-bottom: 1px solid black;
}

.datas-table th, .datas-table td {
  padding: 2px 8px;
}

.datas-table tbody tr:nth-child(odd) {
  background-color: #EFEFEF;
}

.datas-table tbody tr:nth-child(even) {
  background-color: #C5C5C5;
}

.datas-table td.with-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.datas-table .number {
  text-align: right;
}

.datas-table .tag > div {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.datas-table .tag > div.green {
  background-color: #388E3C;
}

.datas-table .tag > div.orange {
  background-color: #FFC107;
}

.datas-table .tag > div.red {
  background-color: #D32F2F;
}

.trend-indicator {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  font-size: 0.8em;
}

.trend-indicator.up {
  color: #388E3C;
}

.trend-indicator.up::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23388E3C%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%2017l6-6l4%204l8-8%22%2F%3E%3Cpath%20d%3D%22M17%207h4v4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

.trend-indicator.down {
  color: #D32F2F;
}

.trend-indicator.down::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23D32F2F%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%207l6%206l4-4l8%208%22%2F%3E%3Cpath%20d%3D%22M17%2017h4v-4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/RecapPage/FrsGammesCaRfaInfosTile.vue